/**
 * The product mark: Julius with a brick, cut from the approved hackathon
 * artwork. Decorative wherever it appears beside the product name.
 *
 * `public/favicon.svg` is the same drawing on a royal tile; change both
 * together.
 */
export default function Logo({ className = 'size-8' }: { className?: string }) {
  return <img src="/art/julius-brick.svg" alt="" aria-hidden="true" className={`inline-block shrink-0 ${className}`} />
}
